import { SxProps, Theme } from "@mui/material";

export const containerSx = {
  width: "100%",
  maxHeight: "calc(100vh - 230px)",
  overflowY: "auto",
  pr: 1,
};